export const transitionDuration = 1400; // ms
